import { useState } from "react";
import "./ServiciosForm.css";

const TIPO_SERVICIO_OPTIONS = [
    { value: "ESPECIALIDAD", label: "Especialidad" },
    { value: "PRACTICA", label: "Práctica" },
];

const ServiciosForm = ({ initialValue, onCancel, onSubmit, saving }) => {
    const [form, setForm] = useState({
        nombre: initialValue?.nombre || "",
        descripcion: initialValue?.descripcion || "",
        tipoServicio: initialValue?.tipoServicio || "ESPECIALIDAD",
        duracionEnMinutos: initialValue?.duracionEnMinutos ?? "",
        costoConsulta: initialValue?.costoConsulta ?? "",
        activo: initialValue?.activo ?? true,
    });

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setForm((currentForm) => ({
            ...currentForm,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit({
            nombre: form.nombre.trim(),
            descripcion: form.descripcion.trim(),
            tipoServicio: form.tipoServicio,
            duracionEnMinutos: Number(form.duracionEnMinutos),
            costoConsulta: Number(form.costoConsulta),
            activo: form.activo,
        });
    };

    return (
        <form className="servicios-form" onSubmit={handleSubmit}>
            <div className="servicios-form__header">
                <div>
                    <p>{initialValue ? "Editar" : "Nuevo"}</p>
                    <h2>{initialValue ? "Editar servicio" : "Nuevo servicio"}</h2>
                </div>

                <button type="button" onClick={onCancel}>
                    ×
                </button>
            </div>

            <label className="servicios-form__field">
                <span>Nombre</span>
                <input
                    name="nombre"
                    value={form.nombre}
                    onChange={handleChange}
                    placeholder="Cardiología"
                    minLength={3}
                    maxLength={40}
                    required
                />
            </label>

            <label className="servicios-form__field">
                <span>Descripción</span>
                <textarea
                    name="descripcion"
                    value={form.descripcion}
                    onChange={handleChange}
                    placeholder="Descripción breve del servicio"
                    rows="4"
                    maxLength={250}
                    required
                />
            </label>

            <label className="servicios-form__field">
                <span>Tipo de servicio</span>
                <select
                    name="tipoServicio"
                    value={form.tipoServicio}
                    onChange={handleChange}
                    required
                >
                    {TIPO_SERVICIO_OPTIONS.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                            {opt.label}
                        </option>
                    ))}
                </select>
            </label>

            <div className="servicios-form__row">
                <label className="servicios-form__field">
                    <span>Duración (minutos)</span>
                    <input
                        type="number"
                        name="duracionEnMinutos"
                        value={form.duracionEnMinutos}
                        onChange={handleChange}
                        placeholder="30"
                        min={1}
                        required
                    />
                </label>

                <label className="servicios-form__field">
                    <span>Costo de consulta ($)</span>
                    <input
                        type="number"
                        name="costoConsulta"
                        value={form.costoConsulta}
                        onChange={handleChange}
                        placeholder="0"
                        min={0}
                        step="0.01"
                        required
                    />
                </label>
            </div>

            <label className="servicios-form__checkbox">
                <input
                    type="checkbox"
                    name="activo"
                    checked={form.activo}
                    onChange={handleChange}
                />
                <span>Servicio activo</span>
            </label>

            <div className="servicios-form__actions">
                <button type="button" className="secondary-button" onClick={onCancel}>
                    Cancelar
                </button>

                <button type="submit" className="primary-button" disabled={saving}>
                    {saving ? "Guardando..." : "Guardar"}
                </button>
            </div>
        </form>
    );
};

export default ServiciosForm;